// extracted by mini-css-extract-plugin
export default {"modeControls":"GameModeController_modeControls__Fdff-","navLink":"GameModeController_navLink__e2DZp"};